<script>
import RecycleModal from './RecycleModal.vue'
import FailModal from './FailModal.vue'
import RedactorControlVue from '../../RedactorControl.vue'
import moment from 'moment'
export default {
    components: {
        RecycleModal,
        FailModal,
        RedactorControlVue
    },

    props: {
        jobApplication: {
            type: Object,
            required: true
        },
        csrfToken: {
            type: String,
            required: true
        },
        logs: {
            type: Object,
            required: false
        },
        sageLog: {
            type: Object,
            required: false
        },
    },

    data() {
        return {
            average: 0,
            rating: [],
            fail_reason: '',
            passBtnDisabled: false,
            loading_offer_status: this.jobApplication.loading_offer_status,
        }
    },

    methods: {
        toggleModal(ref) {
            this.$refs[ref].toggleModal()
        },
        sliceString(value) {
            return value.substring(value.lastIndexOf("/") + 1)
        },
        fail(fail_reason) {
            this.fail_reason = fail_reason
            this.$nextTick(() => {
                this.$refs.failedButton.click();
            });
        },
        convertDate(date, format = 'YYYY-MM-DDThh:mm') {
            return moment.parseZone(date).format(format)
        },
        disablePassBtn() {
            this.passBtnDisabled = true;
            this.loading_offer_status = 'passed';
        },
        parseSageResponse(json) {
            try {
                return JSON.parse(json);
            } catch (e) {
                return false;
            }
        }
    },
    mounted() {
        if (this.jobApplication.loading_offer_status == 'passed') {
            this.passBtnDisabled = true;
        }
    },
    watch: {
        //watch jobApplication deep true
        jobApplication: {
            handler: function (newVal, oldVal) {
                this.passBtnDisabled = false;
                if (newVal.loading_offer_status == 'passed') {
                    this.passBtnDisabled = true;
                }
            },
            deep: true
        }
    },
    computed: {
        disabled() {
            return (this.jobApplication.panel_interview_status === null || this.jobApplication.panel_interview_status === '') ? true : false
        }
    }
}
</script>

<template>
    <div class="telephonic-screening">
        <div class="grid-x grid-padding-x">
            <div class="cell small-6" style="border-right: solid 1px #D1D1D1; padding: 30px 35px">
                <div style="width:90%;">
                    <form method="post" ref="panelInterviewForm" class="pt-0">
                        <input type="hidden" name="_csrfToken" :value="csrfToken" />
                        <strong>Onboarding Invitation</strong>
                        <p>Invite candidate to an orboarding session. Please specify the details of the boarding session
                            below:</p>
                        <br>
                        <strong>Date & Time</strong>
                        <input
                            :disabled="disabled"
                            type="datetime-local"
                            name="job_offer[onboarding_datetime]"
                            :value="(jobApplication.job_offer) ? convertDate(jobApplication.job_offer.onboarding_datetime) : convertDate(this.value)"
                            required
                        />
                        <br />
                        <strong>Venue/ location</strong>
                        <textarea 
                            :disabled="disabled"
                            name="job_offer[venue]" required
                            :value="(jobApplication.job_offer) ? jobApplication.job_offer.venue : ''"
                        ></textarea>
                        <br />
                        <strong>Google maps link </strong>
                        <input 
                            :disabled="disabled"
                            type="text"
                            name="job_offer[google_maps_link]" 
                            required
                            :value="(jobApplication.job_offer) ? jobApplication.job_offer.google_maps_link : ''" />
                        <br />
                        <strong>Contact Person</strong>
                        <input
                            type="text"
                            name="job_offer[contact_person]"
                            required
                            :value="(jobApplication.job_offer) ? jobApplication.job_offer.contact_person : ''"
                        />
                        <br />
                        <strong>Contact Number</strong>
                        <input 
                            type="text" name="job_offer[contact_number]" 
                            required
                            :value="(jobApplication.job_offer) ? jobApplication.job_offer.contact_number : ''" 
                        />
                        <br />
                        <strong>Other Notes</strong>
                        <RedactorControlVue name="job_offer[notes]"
                            :value="(jobApplication.job_offer) ? jobApplication.job_offer.notes : ''" />
                        <br />
                        <div class="grid-x grid-padding-x">
                            <div class="cell shrink">
                                <button :disabled="disabled" class="button" name="send-offer" type="submit">Send</button>
                            </div>
                            <div class="cell shrink">
                                <button :disabled="disabled" class="button" name="send-offer-manually" type="submit">Set time manually</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <div class="cell small-6 p-4">
                <div class="small-12">
                    <form method="post" ref="panelInterviewForm" v-on:submit="disablePassBtn">
                        <div style="width:90%;">
                                <!-- <strong>Invitation Status:</strong> {{ jobApplication.job_offer ? jobApplication.job_offer.status.toString().replace('_',' ') : '' }}
                                <div v-if="jobApplication.job_offer && jobApplication.job_offer.status == 'declined'">
                                    <strong>Decline Reason:</strong><br>
                                    <span>{{ jobApplication.job_offer.declined_reason }}</span>
                                </div> -->
                                <input type="hidden" name="_csrfToken" :value="csrfToken" />
                                <input type="hidden" name="fail_reason" :value="fail_reason" />
                                <input type="hidden" name="loading_offer_status" :value="loading_offer_status">

                                <h4>Invitation</h4>
                                <div v-if="jobApplication.job_offer">
                                    <strong>Invitation Status:</strong> {{ (jobApplication.job_offer.status === 'reschedule') ? 'The candidate is not available.  Please resend a new invitation.' : jobApplication.job_offer.status }}
                                    <br>
                                    <strong>Date and Time Scheduled:</strong>{{ jobApplication.job_offer.onboarding_datetime ?
                                        convertDate(jobApplication.job_offer.onboarding_datetime, 'MMMM D, YYYY H:mm') : '' }}
                                    <br>
                                </div>
                                <div v-else>
                                    <strong>Invitation Status:</strong> Not yet sent
                                    <br>
                                    <strong>Date and Time Scheduled:</strong> Not yet set
                                    <br>
                                </div>

                                <strong>Final Status:</strong> {{ jobApplication.loading_offer_status }}
                                <span v-if="logs !== null && logs !== ''">
                                    &nbsp;(Updated By {{ logs.user.first_name }} {{ logs.user.last_name }} - {{ convertDate(logs.created, 'YYYY-MM-DD HH:mm') }})
                                </span>
                                <div class="grid-x grid-padding-x">
                                    <div class="cell shrink">
                                        <button class="button px-5" type="submit" :disabled="passBtnDisabled || disabled">Pass</button>
                                    </div>
                                    <div>
                                        <button class="d-none" value="failed" ref="failedButton" name="loading_offer_status"></button>
                                        <button :disabled="disabled" class="button alert px-5" type="button" @click="toggleModal('failModal')">Fail</button>
                                    </div>
                                    <div class="cell shrink">
                                        <button :disabled="disabled" class="button recycle px-5" type="button" @click="toggleModal('recycleModal')">Recycle</button>
                                    </div>
                                </div>
                        </div>
                    </form>

                    <fail-modal ref="failModal" :job-application="jobApplication" @submit="fail" />
                    <recycle-modal ref="recycleModal" :job-application="jobApplication" :csrf-token="csrfToken" />
                </div>

                <div v-if="sageLog" class="small-12 mt-5">
                    <label class="fw-bold">Sage sync status:</label><br>
                    <span v-if="sageLog.completed" class="text-green">Synced</span>
                    <span v-if="!sageLog.completed && sageLog.failed > 0" class="text-red">Failed</span>

                    <div v-if="!sageLog.completed && sageLog.failed > 0 && sageLog.log_entries[0]" class="mt-4">
                        <div  v-if="sageLog.log_entries[0].response_data.includes('{')">
                            <label class="fw-bold">Parsed Sage Response:</label><br>
                            <ul>
                                <li v-for="rule in parseSageResponse('{' + sageLog.log_entries[0].response_data.split('{').slice(1).join('{')).businessRules" :key="rule.PropertyName">
                                    {{ rule.PropertyFriendlyName }}
                                    <ul v-if="rule.WarningRulesCollection">
                                        <li v-for="message in rule.WarningRulesCollection" :key="message">
                                            {{ message.Message }}
                                        </li>
                                    </ul>

                                    <ul v-if="rule.ErrorRulesCollection">
                                        <li v-for="message in rule.ErrorRulesCollection" :key="message">
                                            {{ message.Message }}
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                            <br/>
                        </div>
                        <label class="fw-bold">Error Response:</label><br>
                        <div v-if="sageLog.log_entries[0].response_data.includes('{')">
                            <pre>{{ '{' + sageLog.log_entries[0].response_data.split('{').slice(1).join('{') }}</pre>
                        </div>
                        <div v-else>
                            <pre>{{ sageLog.log_entries[0].response_data }}</pre>
                        </div>

                        <div>
                            <label class="fw-bold">Payload Sent:</label><br>
                            <pre>{{ sageLog.log_entries[0].request_data }}</pre>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>